<template>
    <div id="generate-wrapper">
        <!-- <zm-sticky
            enabled
            checkPosition="bottom"
            :bottom-offset="300"
            :offset="100"
            >
            <div class="description" style="margin: 0;width: 100%">
                <div> -->
        <zm-row>
        <zm-button type="primary" @click="generate" style="margin-right: 10px;float: right" :loading="loading">Save Dadashboard</zm-button>
        <zm-button plain icon="zm-icon-add" @click="addCard" style="margin-right: 10px;float: right">Add Card</zm-button>
        <zm-button type="danger" plain @click="back" style="margin-right: 10px;float: right">Cancel</zm-button>
        </zm-row>
                <!-- </div>
            </div>
        </zm-sticky> -->
        <zm-form :model="form" :rules="rules" label-position="left" ref="form" label-width="180px"
        style="margin: 20px 40px 20px 40px">
            <zm-form-item prop="name">
                <div slot="label">
                    <tip label="Dashboard" id="manage-dashboard-name"></tip>
                </div>
                <zm-input size="small" v-model="form.name"></zm-input>
            </zm-form-item>
            <zm-form-item prop="description">
                <div slot="label">
                    <tip label="Description" id="manage-dashboard-description"></tip>
                </div>
                <zm-input size="small" v-model="form.description"></zm-input>
            </zm-form-item>
            <zm-form-item prop="groupName">
                <div slot="label">
                    <tip label="GroupName" id="manage-dashboard-groupName"></tip>
                </div>
                <zm-select size="small" v-model="form.groupName" filterable allow-create>
                    <zm-option v-for="item in groups" :key="item" :label="item" :value="item"></zm-option>
                </zm-select>
            </zm-form-item>
            <zm-form-item label-width="0">
                <zm-checkbox v-model="form.active">
                    <tip label="Active" id="manage-dashboard-active"></tip>
                </zm-checkbox>
            </zm-form-item>
        </zm-form>
        <div v-for="(item, index) in generateMetricsCardQueries" :key="index" :class="item.showCard ? 'generate-card' : ''">
            <!-- <a :id="'end' + index" name="1" href="'#' + index">&nbsp;</a> -->
            <card :generateMetricsCardQuery="item" :index="index" :ref="'card_' + index" :databaseList="databases" :id="'card_' + index"
            @deleteCard="deleteCard" v-show="item.showCard"></card>
        </div>
    </div>
</template>
<script>
import { listGroupName, listMyDataBases, generateClusterDashboardQueries, generateTopicDashboardQueries, saveDashboard } from '@/api/manageDashboard'
import tip from 'components/ToolTip/index'
import Card from './card.vue'
export default {
    name: 'generateDashboard',
    components: { tip, Card },
    data () {
        return {
            loading: false,
            cardType: 'CUBE_MONITOR',
            channelId: '',
            topicUrl: '',
            cardTypeList: ['CUBE_MONITOR'],
            form: {
                name: '',
                active: false,
                description: '',
                groupName: ''
            },
            generateMetricsCardQueries: [],
            databases: [],
            groups: [],
            rules: {
                name: [
                    { required: true, message: 'please enter name', trigger: 'blur' }
                ],
                description: [
                    { required: true, message: 'please enter description', trigger: 'blur' }
                ],
                groupName: [
                    { required: true, message: 'please enter groupName', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        this.channelId = this.$route.params.channelId
        this.topicUrl = this.$route.params.topicUrl
        this.fetchData()
        this.fetchDatabase()
        this.fetchGroup()
    },
    methods: {
        fetchGroup () {
            listGroupName().then(response => {
                this.groups = response
            })
        },
        fetchDatabase () {
            this.loadingService = true
            listMyDataBases().then(response => {
                this.databases = response
                this.loadingService = false
            }).catch(() => {
                this.loadingService = false
            })
        },
        generate () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const generateMetricsCardQueries = []
                    this.generateMetricsCardQueries.map((item, index) => {
                        if (item.showCard) {
                            const { fields, measurements, form } = this.$refs['card_' + index][0]
                            const fieldFuncParams = []
                            fields.map(field => {
                                field.checkedFunc.map(func => {
                                    fieldFuncParams.push({
                                        fieldName: field.label,
                                        selectAggFunc: func
                                    })
                                })
                            })
                            const tags = []
                            const labels = {}
                            measurements.map(measurement => {
                                measurement.children.map(tag => {
                                    if (tag.isGroup) {
                                        tags.push(tag.label)
                                    }
                                    if (tag.children.length && tag.children[0].value.length) {
                                        labels[tag.label] = tag.children[0].value
                                    }
                                })
                            })
                            generateMetricsCardQueries.push({
                                active: form.active,
                                cardType: this.cardType,
                                cubeMonitorQuery: {
                                    database: form.cubeMonitorQuery.database,
                                    fieldFuncParams,
                                    labels,
                                    limit: form.cubeMonitorQuery.limit,
                                    measurement: form.cubeMonitorQuery.measurement,
                                    tags: []
                                },
                                description: form.description,
                                name: form.name
                            })
                        }
                    })
                    const data = {
                        active: this.form.active,
                        description: this.form.description,
                        groupName: this.form.groupName,
                        name: this.form.name,
                        saveMetricsCardParamList: generateMetricsCardQueries
                    }
                    this.loading = true
                    saveDashboard(data).then(response => {
                        this.loading = false
                        this.$message.success('Create success')
                        this.$router.push({
                            path: '/dashboard/manage/dashboard',
                            query: {
                                id: response.id,
                                group: response.groupName
                            }
                        })
                    }).catch(() => {
                        this.loading = false
                    })
                }
            })
        },
        deleteCard (index) {
            this.generateMetricsCardQueries[index].showCard = false
        },
        addCard () {
            this.generateMetricsCardQueries.push({
                name: '',
                description: '',
                active: false,
                cardType: '',
                showCard: true,
                cubeMonitorQuery: {
                    database: '',
                    fieldFuncParams: [],
                    labels: {},
                    limit: 0,
                    measurement: '',
                    tags: []
                }
            })
            this.$nextTick(() => {
                var msgEnd = document.getElementById('card_' + (this.generateMetricsCardQueries.length - 1))
                msgEnd.scrollIntoView()
            })
        },
        fetchData () {
            const data = {
                cardType: this.cardType,
                channelId: this.channelId,
                topicUrl: this.topicUrl
            }
            if (this.topicUrl) {
                generateTopicDashboardQueries(data).then(response => {
                    this.form.name = response.name
                    this.generateMetricsCardQueries = response.generateMetricsCardQueries.map(item => {
                        item.showCard = true
                        return item
                    })
                })
            } else {
                generateClusterDashboardQueries(data).then(response => {
                    this.form.name = response.name
                    this.generateMetricsCardQueries = response.generateMetricsCardQueries.map(item => {
                        item.showCard = true
                        return item
                    })
                })
            }
        },
        back () {
            if (this.topicUrl) {
                this.$router.push({
                    path: '/dashboard/manage/cluster/describe/' + this.channelId + '/topic',
                    query: {
                        topicUrl: this.topicUrl
                    }
                })
            } else {
                this.$router.push('/dashboard/manage/cluster')
            }
        }
    }
}
</script>
<style scoped>
.generate-card {
    border: solid 1px rgb(228, 228, 231);
    border-radius: 12px;
    padding: 20px;
    margin: 20px;
}
.generate-card:hover {
    box-shadow: 0 2px 12px 0 #0E71EB;
}
</style>
